import { TFunction, Trans } from '@sortlist-frontend/translation';

export const getServerErrors = (t: TFunction, showIntercom: () => void) => {
  return {
    email: {
      taken: (
        <Trans i18nKey={'agency:claim.form.errors.emailTaken'}>
          This email is already used by another provider.&nbsp;
          <span role="none" onClick={showIntercom} className="underline cursor-pointer">
            Contact our support team
          </span>
          &nbsp;for assistance.
        </Trans>
      ),
      invalid: t('agency:claim.form.errors.invalidEmail'),
      domain_mismatch: t('agency:claim.form.errors.domainMismatch'),
      domain_unauthorized: t('agency:claim.form.errors.invalidEmail'),
    },
    phone: {
      taken: (
        <Trans i18nKey={'agency:claim.form.errors.phoneTaken'}>
          This phone is already used by another provider.&nbsp;
          <span role="none" onClick={showIntercom} className="underline cursor-pointer">
            Contact our support team
          </span>
          &nbsp;for assistance.
        </Trans>
      ),
    },
    website: {
      taken: (
        <Trans i18nKey={'agency:claim.form.errors.websiteTaken'}>
          This website is already used by another provider.&nbsp;
          <span role="none" onClick={showIntercom} className="underline cursor-pointer">
            Contact our support team
          </span>
          &nbsp;for assistance.
        </Trans>
      ),
      invalid_url: t('agency:claim.form.errors.invalidUrl'),
    },
  };
};
